var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_47680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2415 5.74262L17.2425 5.74286C17.685 5.85463 18.0856 6.09257 18.3949 6.42809L18.4011 6.4357C18.7152 6.76355 18.9253 7.17687 19.0049 7.62391L19.0076 7.63671L22.1544 23.043L22.1564 23.0506C22.2339 23.4041 22.2263 23.7716 22.1365 24.124C22.0994 24.2691 22.0476 24.4082 21.9807 24.5408L21.9769 24.5478L21.974 24.5552C21.7551 25.0254 21.387 25.4103 20.9274 25.6507L20.9262 25.6514C20.4646 25.8951 19.9358 25.9822 19.4204 25.9C18.9102 25.8185 18.4398 25.5757 18.0785 25.2067L14.3106 20.7073L14.2744 20.6637L14.2298 20.6292L14.0596 20.5142C13.8857 20.4084 13.6976 20.3293 13.5018 20.2791L13.4999 20.2786C13.2091 20.2028 12.9045 20.1976 12.611 20.2623L12.5748 20.2702L12.5401 20.2835L7.41723 22.2414C6.91606 22.3892 6.38045 22.3683 5.8929 22.1799L5.88912 22.1789C5.41596 21.9998 5.01191 21.6748 4.73501 21.2514C4.45867 20.8287 4.32321 20.3295 4.34817 19.8252C4.37699 19.3139 4.56259 18.8234 4.87904 18.4207L4.87833 18.4195L14.7946 6.51593C15.0888 6.1724 15.4741 5.91849 15.9053 5.78149C16.3382 5.64399 16.8014 5.63038 17.2415 5.74262Z",
    fill: "#9747FF",
    stroke: "#F2807A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_47680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6.33984 0.40625) rotate(14.3194)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.2cc2d485672afb340a3acc2b611653c6.svg";
export { ForwardRef as ReactComponent };